import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { PROGRAM_NAMES } from '@/shared/utils/deadline';
import {
    STUDENT_WINDOWS_CLOSED,
    closeLines,
    studentWindowFor,
} from '@/shared/utils/studentWindow';

/**
 * Where a student application window stands for the programs on a page: the
 * close date while it is open, a plain closed state after it. The verdict is
 * the server's (see studentWindow.js); this only words it.
 */
export function StudentWindowClosed({ term, programs }) {
    const reasons = programs
        .map((program) => studentWindowFor(term, program).message)
        .filter(Boolean);
    return (
        <Alert variant="info" data-testid="student-window-closed">
            <p className={reasons.length ? 'fw-semibold mb-1' : 'mb-0'}>
                {STUDENT_WINDOWS_CLOSED}
            </p>
            {reasons.length > 0 && (
                <ul className="mb-0">
                    {reasons.map((reason) => (
                        <li key={reason}>{reason}</li>
                    ))}
                </ul>
            )}
        </Alert>
    );
}

StudentWindowClosed.propTypes = {
    term: PropTypes.object,
    programs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export function StudentWindowCloses({ term, programs, className = '' }) {
    const lines = closeLines(term, programs);
    if (lines.length === 0) return null;
    return (
        <p className={className} data-testid="student-window-closes">
            {lines.map(({ date, programs: list }) => (
                <span key={date} className="d-block">
                    {lines.length === 1
                        ? `Student applications close on ${date} (Mountain time).`
                        : `${list
                              .map((program) => PROGRAM_NAMES[program])
                              .join(
                                  ' and '
                              )} applications close on ${date} (Mountain time).`}
                </span>
            ))}
        </p>
    );
}

StudentWindowCloses.propTypes = {
    term: PropTypes.object,
    programs: PropTypes.arrayOf(PropTypes.string).isRequired,
    className: PropTypes.string,
};
